export class PolicyMessages {
  public button = 'policy.button';
  public download = 'policy.download';
  public get = 'policy.get';
  public verifySignature = 'policy.verify_signature';
  public createSignature = 'policy.create_signature';
  public size = 'policy.size';
  public type = 'policy.type';
  public typeSize = 'policy.type_size';

  constructor() {
  }
}
